import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Объединяет классы и разрешает конфликты Tailwind.
 * Без этого переданный снаружи `className` не может переопределить
 * класс компонента: в CSS выигрывает не последний в строке, а более поздний в файле.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
